module.exports = require("@wildboar/x500/src/lib/modules/AttributeCertificateDefinitions/AttributeDescriptorSyntax.ta");